export default __webpack_public_path__ + "static/media/26.29ee595e.svg";